<template>
  <div :class="{amCnt: true, show: showAm, showMenu: showMenu}"
    :style="{top: `${amRect.y - cntRect.y}px`, left: `${amRect.x - cntRect.x}px`}">
    <div class="addMedia" v-on:click="showMenu = !showMenu"/>
    <div class="amOverlay" v-on:click="showMenu = false"/>
    <div class="mediaIcon img" v-on:click="addMedia('img')"/>
    <div class="mediaIcon yt" v-on:click="addMedia('yt')"/>
    <!-- <div class="mediaIcon ig" v-on:click="addMedia('ig')"/> -->
    <!-- <div class="mediaIcon tw" v-on:click="addMedia('tw')"/> -->
    <!-- <div class="mediaIcon embed" v-on:click="addMedia('embed')"/> -->
    <MediaInputer ref="mediaInputer"/>
    <LoadingDialog ref="loadingDialog"/>
    <MediaUploader ref="mediaUploader"/>
  </div>
</template>

<script>
import MediaInputer from '@/components/MediaInputer.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import MediaUploader from '@/components/MediaUploader.vue';

export default {
  components: {
    MediaUploader, MediaInputer, LoadingDialog,
  },
  data() {
    return {
      showMediaSelector: false,
      showMenu: false,
      showAm: true,
      currentLine: null,
      cntRect: { x: 0, y: 0 },
      amRect: { x: 0, y: 0 },
      editorFocuesd: false,
      mediaRect: { x: 0, y: 0 },
      showMediaInputer: false,
    };
  },
  props: [
    'editor', 'editorCnt',
  ],
  methods: {
    validateYouTubeUrl(url) {
      if (!url || url === '') {
        return false;
      }
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/; //eslint-disable-line
      const match = url.match(regExp);
      const videoId = (match && match[2].length === 11) ? match[2] : false;
      return videoId;
    },
    addMedia(type) {
      this.showMenu = false;
      document.getElementsByTagName('BODY')[0].classList.add('selectingMedia');

      if (type === 'yt') {
        this.$refs.mediaInputer.open({
          title: 'Youtube Video Url',
          placeholder: 'Paste youtube video link here...',
          action: 'Insert Video',
        }, (b, uri) => {
          setTimeout(() => {
            document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
          }, 200);
          if (!b) return;
          const videoId = this.validateYouTubeUrl(uri);
          if (!videoId) return;
          const nodes = this.editor.elements[0].querySelectorAll('.activeNode');
          if (nodes && nodes.length > 0) {
            this.editor.elements[0].classList.remove('medium-editor-placeholder');
            const mediaCnt = document.createElement('P');
            const theMedia = document.createElement('IFRAME');
            theMedia.classList.add('theMedia');
            theMedia.classList.add('youtube');
            theMedia.frameborder = 0;
            theMedia.allowfullscreen = true;
            theMedia.src = `https://www.youtube.com/embed/${videoId}`;
            mediaCnt.appendChild(theMedia);
            this.editor.elements[0].insertBefore(mediaCnt, nodes[0]);
            this.editor.selectElement(nodes[0]);
            setTimeout(() => {
              this.cntRect = this.editorCnt.getBoundingClientRect();
              this.amRect = nodes[0].getBoundingClientRect();
              this.$emit('changed');
            }, 200);
          }
        });
      } else if (type === 'ig' || type === 'tw' || type === 'embed') {
        let title = '';
        let placeholder = '';
        if (type === 'ig') {
          title = 'Instagram Post';
          placeholder = 'Paste instagram embed code here...';
        } else if (type === 'tw') {
          title = 'Embed Tweet';
          placeholder = 'Paste tweet embed code here...';
        } else {
          title = 'Embed Code';
          placeholder = 'Paste embed code here...';
        }
        this.$refs.mediaInputer.open({
          title,
          placeholder,
          action: 'Insert Embed',
          type,
        }, (b, code) => {
          if (!b) {
            setTimeout(() => {
              document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
            }, 200);
            return;
          }
          this.$refs.loadingDialog.open();
          this.$http.post(this.$config.uri('media/add/embed'), { code }).then((r) => {
            setTimeout(() => {
              document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
            }, 200);
            this.$refs.loadingDialog.close();
            if (r.data.status !== 200) return;
            const nodes = this.editor.elements[0].querySelectorAll('.activeNode');
            if (nodes && nodes.length > 0) {
              this.editor.elements[0].classList.remove('medium-editor-placeholder');
              const mediaCnt = document.createElement('P');
              const theMedia = document.createElement('IFRAME');
              theMedia.classList.add('theMedia');
              theMedia.classList.add('theEmbed');
              theMedia.classList.add(type);
              theMedia.frameborder = 0;
              theMedia.allowfullscreen = true;
              theMedia.scrolling = false;
              theMedia.src = `/api/v1/media/embed/${r.data.id}`;
              mediaCnt.appendChild(theMedia);
              this.editor.elements[0].insertBefore(mediaCnt, nodes[0]);
              this.editor.selectElement(nodes[0]);
              setTimeout(() => {
                this.cntRect = this.editorCnt.getBoundingClientRect();
                this.amRect = nodes[0].getBoundingClientRect();
                theMedia.height = theMedia.contentWindow.document.body.scrollHeight;
                theMedia.contentWindow.window.addEventListener('resize', () => {
                  setTimeout(() => {
                    theMedia.height = theMedia.contentWindow.document.body.scrollHeight;
                  }, 400);
                });
              }, 200);
              setTimeout(() => {
                theMedia.height = theMedia.contentWindow.document.body.scrollHeight;
                this.$emit('changed');
              }, 1800);
            }
          });
        });
      } else {
        this.$refs.mediaUploader.open({
          type: 'image',
        }, (b, m) => {
          document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
          if (!b) return;
          this.getLastMedia((media) => {
            const nodes = this.editor.elements[0].querySelectorAll('.activeNode');
            if (nodes && nodes.length > 0) {
              this.editor.elements[0].classList.remove('medium-editor-placeholder');
              const mediaCnt = document.createElement('P');
              const theMedia = document.createElement('IMG');
              theMedia.src = media.imageLg;
              theMedia.classList.add('theMedia');
              theMedia.classList.add('img');
              theMedia.setAttribute('mediaid', media.id);
              theMedia.addEventListener('click', () => {
                const oldMdOpt = this.editor.elements[0].querySelectorAll('.mediaOptions');
                if (oldMdOpt && oldMdOpt.length > 0) {
                  oldMdOpt.forEach((oldMd) => {
                    oldMd.remove();
                  });
                }
                const theEl = this.editor.elements[0].querySelectorAll('.active');
                if (theEl && theEl.length > 0) {
                  theEl.forEach((node) => {
                    node.classList.remove('active');
                  });
                }
                theMedia.classList.add('active');
                mediaCnt.classList.add('active');
                const mediaOptions = document.createElement('DIV');
                mediaOptions.setAttribute('contenteditable', false);
                mediaOptions.classList.add('mediaOptions');
                const mdIn = document.createElement('DIV');
                mdIn.classList.add('mdOpt');
                mdIn.classList.add('mdIn');
                mediaOptions.appendChild(mdIn);
                const mdWd = document.createElement('DIV');
                mdWd.classList.add('mdOpt');
                mdWd.classList.add('mdWd');
                mediaOptions.appendChild(mdWd);
                mediaCnt.insertBefore(mediaOptions, theMedia);
                mdIn.addEventListener('click', () => {
                  theMedia.classList.remove('md-wide');
                });
                mdWd.addEventListener('click', () => {
                  theMedia.classList.add('md-wide');
                });
              });
              mediaCnt.appendChild(theMedia);
              this.editor.elements[0].insertBefore(mediaCnt, nodes[0]);
              this.editor.selectElement(nodes[0]);
              setTimeout(() => {
                this.cntRect = this.editorCnt.getBoundingClientRect();
                this.amRect = nodes[0].getBoundingClientRect();
                this.$emit('changed');
              }, 200);
            }
          });
        });
      }
    },
    getLastMedia(next) {
      this.$refs.loadingDialog.open();
      this.$http.get(this.$config.uri('media/user/all?limit=1')).then((r) => {
        this.$refs.loadingDialog.close();
        if (r.data.status !== 200) return;
        next(r.data.data[0]);
      });
    },
    subscribe() {
      this.editor.subscribe('editableKeydown', this.editorChanged);
      this.editor.subscribe('editableKeyup', this.editorChanged);
      this.editor.subscribe('editableClick', this.editorClicked);
      this.editor.subscribe('blur', this.editorBlured);
    },
    unsubscribe() {
      this.editor.unsubscribe('editableKeydown', this.editorChanged);
      this.editor.unsubscribe('editableKeyup', this.editorChanged);
      this.editor.unsubscribe('editableClick', this.editableClick);
      this.editor.unsubscribe('blur', this.editorBlured);
    },
    editorClicked(e) {
      this.detectList(e);
      if (!e.target.classList.contains('mediaOptions')
        && !e.target.classList.contains('theMedia')
        && !e.target.classList.contains('mdOpt')) {
        this.disableMediaOption();
      }
    },
    disableMediaOption() {
      const theEl = this.editor.elements[0].querySelectorAll('.mediaOptions');
      if (theEl && theEl.length > 0) {
        theEl.forEach((node) => {
          node.remove();
        });
      }
      const theEl2 = this.editor.elements[0].querySelectorAll('.active');
      if (theEl2 && theEl2.length > 0) {
        theEl2.forEach((node) => {
          node.classList.remove('active');
        });
      }
    },
    editorBlured() {
      this.disableMediaOption();
    },
    editorChanged(e) {
      this.detectList();
      if (e.keyCode === 8 || e.keyCode === 46) {
        const activeMedia = this.editor.elements[0].querySelectorAll('.theMedia.active');
        if (activeMedia && activeMedia.length > 0) {
          activeMedia.forEach((md) => {
            md.parentElement.remove();
          });
        }
      }
    },
    detectList() {
      this.currentLine = this.editor.getSelectedParentElement();
      const textContent = this.currentLine.textContent.trim();
      const elRect = this.currentLine.getBoundingClientRect();
      this.cntRect = this.editorCnt.getBoundingClientRect();
      this.amRect = elRect;
      this.showAm = (textContent === '' && this.currentLine.nodeName === 'P');
      const nodes = this.editor.elements[0].querySelectorAll('.activeNode');
      if (nodes && nodes.length > 0) {
        nodes.forEach((node) => {
          node.classList.remove('activeNode');
        });
      }
      this.currentLine.classList.add('activeNode');
    },
  },
  mounted() {
    this.cntRect = this.editorCnt.getBoundingClientRect();
    this.amRect = this.editorCnt.getBoundingClientRect();
    this.amRect.y += 10;
    this.editor.elements[0].innerHTML = '<p class="activeNode"><br></p>';
    this.subscribe();
  },
  destroyed() {
    this.unsubscribe();
  },
};
</script>

<style lang="scss">
  body.selectingMedia{
    overflow: hidden;
    .formAction{
      display: none;
    }
    .contentHeader{
      display: none;
    }
  }
  .editorCnt{
    .editor{
      .active{
        position: relative;
        z-index: 2;
      }
      input.mediaInputer{
        border: none;
        font-size: 18px;
        padding: 0;
        width: 100%;
        outline: 0;
        text-align: left;
      }
      .theMedia{
        // pointer-events: none;
        cursor: pointer;
        display: block;
        width: 100%;
        position: relative;
        // border-radius: 5px;
        max-width: none;
        margin: 20px 0;
        &.img{
          &:hover{
            box-shadow: 5px 5px 0 #ccc;
          }
        }
        &.active{
          box-shadow: 5px 5px 0 #222 !important;
          z-index: 2;
        }
        &.md-wide{
          width: calc(100% + 200px);
          margin: 20px -100px;
        }
        &.youtube{
          height: 400px;
        }
        &.ig{
          border-radius: 0;
          width: 540px;
        }
        &.tw{
          width: 540px;
        }
      }
      .mediaOptions{
        background-color: #222;
        border-radius: 5px;
        position: absolute;
        top: 100%; left: 50%;
        margin-top: 14px;
        transform: translateX(-50%);
        text-align: center;
        padding: 10px 10px 7px;
        line-height: 1;
        .mdOpt{
          width: 26px; height: 26px;
          display: inline-block;
          margin: 0 5px;
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 4px;
          cursor: pointer;
          &:hover{
            background-color: #444;
          }
          &.mdIn{
            background-image: url(../assets/ed-inside.png);
          }
          &.mdWd{
            background-image: url(../assets/ed-wide.png);
          }
        }
        &:before{
          content: "";
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: -7px;
          display: block;
          border-bottom: 7px #000 solid;
          border-left: transparent 7px solid;
          border-right: transparent 7px solid;
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  .amCnt{
    position: absolute;
    margin-left: -42px;
    margin-top: -2px;
    transition: all .1s ease;
    display: none;
    z-index: 3;
    &.show{
      display: block;
    }
    .amOverlay{
      position: fixed;
      left: 0; right: 0; top: 0; bottom: 0;
      z-index: 1;
      display: none;
      // background-color: rgba(255,255,255,.6);
      // backdrop-filter: saturate(180%) blur(20px);
    }
    &.showMenu{
      .amOverlay{
        display: block;
      }
    }
    .addMedia{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      cursor: pointer;
      background-image: url(../assets/plus-circle.png);
      background-position: center;
      background-size: 100% auto;
      background-repeat: no-repeat;
      // opacity: .7;
      z-index: 3;
      position: relative;
      transition: all .3s ease;
      box-shadow: 2px 2px 4px rgba(0,0,0,.1);
      &:hover{
        box-shadow: 2px 2px 4px rgba(0,0,0,.4);
        // opacity: 1;
      }
    }
    &.showMenu{
      .addMedia{
        transform: rotate(135deg);
        // opacity: .8;
        box-shadow: 1px -2px 4px rgba(0,0,0,.1);
        &:hover{
          box-shadow: 1px -2px 4px rgba(0,0,0,.4);
        }
      }
    }
    .mediaIcon{
      position: absolute;
      width: 26px; height: 26px;
      border-radius: 50%;
      left: 0; top: 0;
      opacity: 0;
      cursor: pointer;
      transition: all .3s ease;
      z-index: 2;
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      border: #999 2px solid;
      background-color: #fff;
      box-shadow: 2px 2px 4px rgba(0,0,0,.1);
      &:hover{
        box-shadow: 2px 2px 4px rgba(0,0,0,.4);
      }
    }
    &.showMenu{
      .mediaIcon{
        opacity: 1;
        &:hover{
          opacity: 1;
          border-color: #555;
        }
        &.img{
          left: 36px;
          background-image: url(../assets/image.png);
        }
        &.yt{
          left: 72px;
          background-image: url(../assets/youtube.png);
        }
        &.ig{
          left: 108px;
          background-image: url(../assets/instagram.png);
        }
        &.tw{
          left: 144px;
          background-image: url(../assets/twitter.png);
        }
        &.embed{
          left: 180px;
          background-image: url(../assets/embed-code.png);
        }
      }
    }
  }
</style>
